<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <title>Facebook</title>
    <path d="M8.25 14.0297V24H13.6875V14.0297H17.7422L18.5859 9.44531H13.6875V7.82344C13.6875 5.4 14.6391 4.47188 17.0953 4.47188C17.8594 4.47188 18.4734 4.49062 18.8297 4.52812V0.370313C18.1594 0.1875 16.5187 0 15.5719 0C10.5609 0 8.25 2.36719 8.25 7.47187V9.44531H5.15625V14.0297H8.25Z"/>
</svg>
